import Image from 'next/image';
import { FunctionComponent } from 'react';

import icon from './help.svg';

const HelpIcon: FunctionComponent<RewindIconsProps> = (props) => {
  const { className, alt = '' } = props;

  return (
    <Image
      className={className}
      priority
      src={icon}
      alt={alt}
    />
  );
};

export default HelpIcon;
